export default __webpack_public_path__ + "static/media/certificate_6.63b0cfed.jpg";